import { Component, Input } from '@angular/core';
import * as _ from 'lodash';

class ErrorDef {
    error: string;
    msgEN: string;
    msgVI: string;
    errorProperty: string;
}

@Component({
    selector: '<validation-messages>',
    template: `<div class="has-danger" style="color:red" *ngIf="formCtrl.invalid && (formCtrl.dirty || formCtrl.touched)">
                    <div *ngFor="let errorDef of errorDefsInternal">
                        <div *ngIf="getErrorDefinitionIsInValid(errorDef)" class="form-control-feedback">
                            {{getErrorDefinitionMessage(errorDef)}}
                        </div>
                    </div>
               </div>`
})
export class ValidationMessagesComponent {

    _errorDefs: ErrorDef[] = [];

    @Input() formCtrl;
    @Input() languageVI;
    @Input() set errorDefs(value: ErrorDef[]) {
        this._errorDefs = value;
    }

    readonly standartErrorDefs: ErrorDef[] = [
        { error: 'required', msgEN: 'This field is required', msgVI: 'Quý khách vui lòng nhập thông tin' } as ErrorDef,
        { error: 'minlength', msgEN: 'Please enter at least {0} character', msgVI: 'Độ dài tối thiểu của chuỗi là {0}', errorProperty: 'requiredLength' } as ErrorDef,
        { error: 'maxlength', msgEN: 'Please enter no more than {0} character', msgVI: 'Độ dài tối đa của chuỗi là {0}', errorProperty: 'requiredLength' } as ErrorDef,
        { error: 'email', msgEN: 'Invalid email address', msgVI: 'Sai định dạng email' } as ErrorDef,
        { error: 'pattern', msgEN: 'Invalid Pattern', msgVI: 'Trường thông tin không được chứa ký tự đặc biệt', errorProperty: 'requiredPattern' } as ErrorDef
    ];

    get errorDefsInternal(): ErrorDef[] {
        let standarts = _.filter(this.standartErrorDefs, (ed) => !_.find(this._errorDefs, (edC) => edC.error === ed.error));
        let all = <ErrorDef[]>_.concat(standarts, this._errorDefs);

        return all;
    }

    constructor(
    ) { }

    getErrorDefinitionIsInValid(errorDef: ErrorDef): boolean {
        return !!this.formCtrl.errors[errorDef.error];
    }

    getErrorDefinitionMessage(errorDef: ErrorDef): string {
        let errorRequirement = this.formCtrl.errors[errorDef.error][errorDef.errorProperty];
        if(errorRequirement){
            errorDef.msgVI = errorDef.msgVI.replace('{0}',errorRequirement);
            errorDef.msgEN = errorDef.msgEN.replace('{0}',errorRequirement);
        }

        return this.languageVI ? errorDef.msgVI : errorDef.msgEN;
    }
}

